<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ DuvidaFrequente.cdfId ? 'Alterar dúvida frequente' : 'Novo dúvida frequente' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de dúvidas frequentes</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ DuvidaFrequente.cdfId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-help-circle-outline</v-icon></span>
                                <div>
                                    <h4>{{ DuvidaFrequente.cdfId ? 'Alterar dúvida frequente' : 'Novo dúvida frequente' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="DuvidaFrequente.cdfId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Título</label>
                                            <input v-model="DuvidaFrequente.cdfTitulo"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="DuvidaFrequente.cdfVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoPessoas != ''">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select  v-model="DuvidaFrequente.tpeId" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Texto</label>
                                            <ckeditor :editor="editor" @ready="onReady" v-model="DuvidaFrequente.cdfTexto" :config="$ckconfig"></ckeditor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="DuvidaFrequente.cdfId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()"  class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de dúvidas frequentes</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="TipoPessoas!=''">
                                <adm-data-table :headers="headers" :items="DuvidaFrequentes" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-cdfVisivel="item">
                                        <span>{{ item.cdfVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tpeId="item">
                                        <span>{{ item.tpeId != null ? TipoPessoas.filter(x=> x.tpeId == item.tpeId)[0].tpeNome : '' }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
    name: 'CadastroDuvidaFrequenteView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        editor: DecoupledEditor,
        DuvidaFrequente: {
            cdfId: 0,
            cdfTitulo: '',
            cdfVisivel: '',
            cdfTexto: '',
            tpeId: '',
        },
        DuvidaFrequentes: [],
        selectedVisivel: null,
        headers: [
            { text: "Id", value: "cdfId", sortable: true, },
            { text: "Nome", value: "cdfTitulo", sortable: true, },
            { text: "Visivel", value: "cdfVisivel", sortable: true, },
            { text: "Tipo", value: "tpeId", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        TipoPessoas:[],
    }),
    methods: {
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
          //edit
          EditNew(){
            this.EditView = true;
            this.DuvidaFrequente.cdfId = 0;
            this.DuvidaFrequente.cdfTitulo= '';
            this.DuvidaFrequente.cdfVisivel= '';
            this.DuvidaFrequente.cdfTexto= '';
            this.DuvidaFrequente.tpeId= '';
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.cdfId != ''){
            axios.get(`/Telas/DuvidasFrequentes/GetById/` + item.cdfId)
                .then(response => {
                    this.DuvidaFrequente = response.data;
                });
            }
        },
        Add() {
            if (this.DuvidaFrequente.cdfTitulo == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.DuvidaFrequente.cdfVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else {
                axios.post(`/Telas/DuvidasFrequentes/Add`, this.DuvidaFrequente)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.DuvidaFrequente.cdfTitulo == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.DuvidaFrequente.cdfVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else {
                axios.put(`/Telas/DuvidasFrequentes/Update`, this.DuvidaFrequente)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
          //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.cdfId;
                axios.delete(`/Telas/DuvidasFrequentes/Delete/${param1}`)
                .then(response => {
                    if (response.stacdf == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
       async Get() {
            this.EditView = false;
             await axios.get(`/Telas/DuvidasFrequentes/GetDados`)
               .then(response => {
                  this.DuvidaFrequentes = response.data.duvidasFrequentes;
                  this.TipoPessoas = response.data.tiposPessoas;
           });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
